import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';

interface ClientFilterProps {
  clientOptions: any[];
  selectedClient: string | null;
  onChange: (clientId: string) => void;
  size?: 'small' | 'medium';
  sx?: any;
  disabled?: boolean;
  label?: string;
  showAll?: boolean;
  /**
   * Value the "All" entry carries. Defaults to "" for callers that treat an empty
   * selection as "all". A caller that needs to tell "nothing picked yet" apart from
   * "All picked" passes its own sentinel here and as `selectedClient` — otherwise
   * both states are "", so All can never render as the selected option and
   * clicking it on first open is a no-op change.
   */
  allValue?: string;
  minWidth?: number | string;
}

const ClientFilter: React.FC<ClientFilterProps> = ({
  clientOptions,
  selectedClient,
  onChange,
  size = 'small',
  sx = {},
  disabled = false,
  label = 'Client',
  showAll = false,
  allValue = '',
  minWidth = 180,
}) => {
  // Only show the dropdown if there are 2 or more client options
  if (clientOptions.length < 2) {
    return null;
  }

  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value);
  };

  return (
    <FormControl 
      size={size} 
      sx={{ minWidth, ...sx }} 
      disabled={disabled}
    >
      <InputLabel id="client-select-label">{label}</InputLabel>
      <Select
        labelId="client-select-label"
        value={selectedClient || ""}
        label={label}
        onChange={handleChange}
      >
        {showAll && (
          <MenuItem value={allValue}>All</MenuItem>
        )}
        {clientOptions.map((client: any) => (
          <MenuItem key={client.uid} value={client.uid}>
            {client.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ClientFilter;
